import moment from 'moment';
export default function isDateValidOrEmptyWithDashes(value) {
    return moment(value, 'YYYY-MM-DD', true).isValid() || value === '';
}
